import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getStateAndOtherInfoFromStorage,
  signInAndUp,
} from 'supertokens-auth-react/recipe/thirdparty';

import { ApiConstants } from '@eluve/api-contract';
import { LoadingIcon, useToast } from '@eluve/components';

import { useLoginLoopDetection } from '../useAuthHooks';

export const LoginCallbackPage: React.FC = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { clearLoginLoopDetection } = useLoginLoopDetection();
  const didSignIn = useRef(false);

  useEffect(() => {
    const doSignInAndUp = async () => {
      try {
        clearLoginLoopDetection();

        const state = (await getStateAndOtherInfoFromStorage()) as
          | Record<string, unknown>
          | undefined;

        const response = await signInAndUp({
          options: {
            preAPIHook: async (context) => {
              let body: Record<string, unknown> = {};
              const ogBody = context.requestInit.body;
              if (typeof ogBody === 'string') {
                body = JSON.parse(ogBody);
                body[ApiConstants.INVITE_CODE] =
                  state?.[ApiConstants.INVITE_CODE];
              }

              return {
                url: context.url,
                requestInit: {
                  ...context.requestInit,
                  body: JSON.stringify(body),
                },
              };
            },
          },
        });
        if (response.status !== 'OK') {
          toast.error('Sign in response failed');
        }
      } catch {
        toast.error('An error occurred during authentication');
      } finally {
        navigate('/');
      }
    };

    // https://github.com/reactwg/react-18/discussions/18
    // We only want to run this once. In StrictMode, it will try and
    // consume the OAuth params twice which can lead to weird errors
    // or race conditions in local development.
    if (didSignIn.current === false) {
      didSignIn.current = true;
      doSignInAndUp();
    }
  }, [navigate, clearLoginLoopDetection, toast]);

  return (
    <div className="grid h-screen place-items-center">
      <LoadingIcon size="3xl" className="text-border-accent-quaternary" />
    </div>
  );
};
